import { request_detail, request_list, update_detail, create_detail, remove_detail, export_list, request_header } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import configs from '@/configs';
var FileSaver = require('file-saver');
import Vue from 'vue';
const endpoint = 'pay-authority'
const viewTitle = 'ủy quyền thanh toán'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        ID: 0,
        UID: 0,
        Username: '',
        Status: 2,
        Amount: 0,
        OrderCodes: []
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            const setData = {...data};
            if (data.data && data.data.AcceptPayAccount)  {
                setData.data = { ...setData.data, AcceptPayAccount: data.data.AcceptPayAccount.split(',').map(i => Number(i))}
            }
            commit('setDetail', setData);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setDetail({ dispatch }, {data, id, params}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if(id > 0) {
                    data.ModifiedBy = this.state.authentication.user.username;
                    update_detail(endpoint, res => {
                        if (res.status === 202) {
                            reject(res);
                            sendErrorNotice(res.reason)
                        } else if (res.data.status === 'fail') {
                            reject(res);
                            sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                        }
                        else {
                            sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`)
                            resolve(data);
                            refreshResource();
                        }
                    }, Vue.http, data, id, this.state.authentication.token);
                }
                else {
                    data.CreatedBy = this.state.authentication.user.username;
                    delete data.ID;
                    create_detail(endpoint, res => {
                        if (res.status === 202) {
                            reject(res);
                            sendErrorNotice(res.reason)
                        } else if (res.data  && res.data.status === 'fail') {
                            reject(res);
                            sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                        }
                        else {
                            const successMessage = data.SplitOrderCodes
                                ? `Thêm mới ${data.OrderCodes.length} ${viewTitle} thành công.`
                                : `Thêm mới ${viewTitle} thành công.`;
                            sendSuccessNotice(successMessage);
                            resolve(data);
                            refreshResource();
                        }
                    }, Vue.http, data, this.state.authentication.token);
                }
            }, 100)
        });
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    exportList({ commit }, param) {
        export_list(endpoint, res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, `DanhSachUyQuyen_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
    updateMultiple({ commit }, param) {
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        Vue.http.post(`${configs.API}/admin/api/pay-authority/`, param, header).then(function (res) {
            refreshResource();
        });
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
